import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.filledClass = 'form-input__field--filled';
    this.handleCheckFilled();
  }

  addListeners() {
    this.el.addEventListener('change', this.handleCheckFilled.bind(this));
    this.el.addEventListener('keyup', this.handleCheckFilled.bind(this));
  }

  handleCheckFilled() {
    this.el.classList.toggle(this.filledClass, this.el.value);
  }
}

export default Module;
